<template>
  <div
    :style="[
      isSticky ? containerStyles : null,
      { height: containerHeight + 'px' },
    ]"
    class="asc-sticky--container"
  >
    <div
      ref="ascSticky"
      :class="[
        'asc-sticky',
        { isSticky: isSticky, stickyFooter: stickyFooter },
        customClass,
      ]"
      :style="componentStyles"
    >
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AscSticky',
  props: {
    offsetTop: {
      type: Number,
      default: undefined,
    },
    customClass: {
      type: String,
      default: undefined,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    isSticky: {
      type: Boolean,
      default: false,
    },
    stickyFooter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      elementOffset: {},
      componentStyles: {},
      containerStyles: {},
      containerHeight: 50, // default height
    }
  },

  watch: {
    isSticky(newValue) {
      this.elementOffset = {
        top: `${this.$parent.$el.offsetParent?.offsetTop}px` || '0',
        height: `${this.$parent.$el.offsetHeight}px` || '100%`',
        width: `${this.$parent.$el.offsetWidth - 12}px` || 'inherit', // 6px is padding on each side
      }
      if (newValue) {
        if (this.stickyFooter) {
          this.componentStyles = {
            bottom: '0',
            right: '0',
            width: '100%',
          }
        } else {
          this.componentStyles = {
            top:
              this.offsetTop !== 'undefined'
                ? `${this.offsetTop}px`
                : this.elementOffset?.top,
          }
        }
        this.containerStyles = {
          // Dont remove this as need to watch sticky behaviour after removal
          // The below line was added to avoid flickering in screen with other changes
          // But this is also aking the screen to have horizontal scroll when sticky header is active
          // width: this.fullWidth ? 'inherit' : this.elementOffset?.width,
        }
      } else {
        this.componentStyles = {}
        this.containerStyles = {}
      }
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.containerHeight = this.$refs.ascSticky.clientHeight
    })
  },
}
</script>

<style lang="scss">
.asc-sticky--container {
  width: inherit;

  .asc-sticky {
    right: 0;
    width: inherit;

    &.isSticky {
      top: 0;
      left: $primary-navbar-width;
      width: calc(100% - #{$primary-navbar-width});
      padding: 8px 0;
      background-color: $gray-300;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.17);
      position: fixed;
      z-index: 9998;
      transition: all 0.5s;
    }

    &.isSticky.stickyFooter {
      top: initial;
      width: calc(100% - 140px);
      bottom: 0;
      left: $primary-navbar-width;
    }
  }
}

.asc-content-wrapper--container {
  &.collapsed {
    .asc-sticky--container {
      .asc-sticky {
        &.isSticky {
          width: calc(100% - 48px);
          left: 48px;
        }

        &.isSticky.stickyFooter {
          width: 100%;
          left: 0;
        }
      }
    }
  }
}
</style>
